var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRewardPointsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 36.365,
    viewBox: "0 0 38 36.365",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layers_3199764",
    transform: "translate(0 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39832",
    "data-name": "Path 39832",
    d: "M18.972,18.671a1.188,1.188,0,0,1-.462-.095L.724,10.945a1.213,1.213,0,0,1,0-2.22l17.787-7.63a1.163,1.163,0,0,1,.922,0l17.787,7.63a1.212,1.212,0,0,1,0,2.22l-17.787,7.63A1.188,1.188,0,0,1,18.972,18.671Z",
    transform: "translate(0.055)",
    fill: "#d750ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39833",
    "data-name": "Path 39833",
    d: "M37.221,10.109l-1.853-.8-15.01,6.44a3.51,3.51,0,0,1-2.772,0L2.579,9.314l-1.855.8a1.213,1.213,0,0,0,0,2.22l17.787,7.63a1.172,1.172,0,0,0,.923,0l17.787-7.63a1.213,1.213,0,0,0,0-2.22Z",
    transform: "translate(0 4.745)",
    fill: "#d750ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39834",
    "data-name": "Path 39834",
    d: "M37.221,14.109l-1.853-.8-15.01,6.44a3.51,3.51,0,0,1-2.772,0L2.579,13.314l-1.853.8a1.212,1.212,0,0,0,0,2.22l17.787,7.63a1.172,1.172,0,0,0,.923,0l17.787-7.63a1.213,1.213,0,0,0,0-2.22Z",
    transform: "translate(0 7.027)",
    fill: "#d750ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39835",
    "data-name": "Path 39835",
    d: "M37.221,18.109l-1.853-.8-15.01,6.44a3.51,3.51,0,0,1-2.772,0L2.579,17.314l-1.853.8a1.212,1.212,0,0,0,0,2.22l17.787,7.63a1.172,1.172,0,0,0,.923,0l17.787-7.63a1.213,1.213,0,0,0,0-2.22Z",
    transform: "translate(0 9.31)",
    fill: "#d750ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardPointsIcon);
export default __webpack_public_path__ + "static/media/reward_points_icon.c3b0fa41e133b129166775cdf8371fe5.svg";
export { ForwardRef as ReactComponent };